import { SNACK_BAR_ERROR, SNACK_BAR_SUCCESS } from '../../../services/constants';

export const personKeyOf = (row) => row?.learner?.id;
export const programKeyOf = (row) => row?.program?.id;
export const learnerNameOf = (row) => row?.learner?.name;
export const programNameOf = (row) => row?.program?.name;

export const rowKey = (row) => `${personKeyOf(row)}-${programKeyOf(row)}`;

export const formatCompletionDate = (value) => {
  if (!value) {
    return '—';
  }
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString('en-US');
};

export const formatCourseCertificates = (row) => {
  const required = row.requiredCourseCertificates ?? 0;
  if (required <= 0) {
    return '—';
  }
  const earned = row.earnedCourseCertificates ?? 0;
  return `${earned}/${required} Earned`;
};

export const buildBulkGenerateToast = (payload) => {
  const successCount = payload?.successCount ?? 0;
  const skippedCount = payload?.skippedCount ?? 0;
  const failureCount = payload?.failureCount ?? 0;
  const parts = [`${successCount} certificate(s) generated.`];
  if (skippedCount > 0) {
    parts.push(`${skippedCount} already existed.`);
  }
  if (failureCount > 0) {
    parts.push(`${failureCount} failed.`);
  }
  return {
    type: failureCount > 0 ? SNACK_BAR_ERROR : SNACK_BAR_SUCCESS,
    message: parts.join(' '),
  };
};
